var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "availability-calendar-day-main py-3 text-center border border-left-0",
      class: { selected: _vm.selected }
    },
    [
      _c(
        "div",
        {
          staticClass: "px-2 py-3 rounded font-weight-bold",
          on: { click: _vm.onSelectDay }
        },
        [_vm._v(" " + _vm._s(_vm.day.name) + " ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }